var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M14.5,0a1.44,1.44,0,0,1,1.06.44A1.44,1.44,0,0,1,16,1.5v9A1.5,1.5,0,0,1,14.5,12H1.5a1.44,1.44,0,0,1-1.06-.44A1.44,1.44,0,0,1,0,10.5v-9A1.44,1.44,0,0,1,.44.44,1.44,1.44,0,0,1,1.5,0Zm0,1.5H1.5V2.78c.73.58,2.14,1.69,4.22,3.31L6,6.34a6.87,6.87,0,0,0,1,.75A1.93,1.93,0,0,0,8,7.5a1.93,1.93,0,0,0,1-.41,6.87,6.87,0,0,0,1-.75l.28-.25q3.12-2.4,4.22-3.31Zm-13,9h13V4.69L10.88,7.56a9.25,9.25,0,0,1-1.29.94A3.16,3.16,0,0,1,8,9a3.32,3.32,0,0,1-1.62-.5,12.45,12.45,0,0,1-1.29-.94L1.5,4.69Z"}))));
}

Email.defaultProps = {"viewBox":"0 0 16 12"};

module.exports = Email;

Email.default = Email;
